// src/components/Footer.js
import React, { useState } from "react";
import { Link } from "react-router-dom";
import contactInfo from "../config/contactInfo";

export default function Footer() {
  const [newsEmail, setNewsEmail] = useState("");
  const [newsMsg, setNewsMsg] = useState(null);

  function submitNewsletter(e) {
    e.preventDefault();
    setNewsMsg(null);
    const email = newsEmail.trim();
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      setNewsMsg({ type: "error", text: "Please enter a valid email." });
      return;
    }
    // Front-end placeholder: replace with real API integration if needed
    setNewsMsg({ type: "success", text: "Thank you — you are subscribed (frontend demo)." });
    setNewsEmail("");
  }

  function backToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  return (
    <footer className="site-footer bg-dark text-white pt-5">
      <div className="container">
        <div className="row gy-4">
          {/* Brand + short */}
          <div className="col-12 col-md-4">
            <div className="mb-3 d-flex align-items-center">
              <div className="me-2 display-6 text-primary" aria-hidden>
                <i className="bi bi-globe2"></i>
              </div>
              <div>
                <strong className="d-block">SWSAA</strong>
                <small className="text-muted">Web development • Testing • DevOps</small>
              </div>
            </div>

            <p className="small text-white-50">
              Build fast, accessible and tested websites for small businesses. Quality work with clear communication.
            </p>

            <div className="mt-3">
                <div className="row">
                    <a className="me-3 text-white-50" href={`mailto:${contactInfo.email}`} aria-label="Email">
                                    <i className="bi bi-envelope-fill me-1"></i>
                                    <span className="small">{contactInfo.email}</span>
                                </a>
                </div>
                <div className="row">
                <a className="text-white-50" href={`tel:${contactInfo.phone.replace(/\s+/g, "")}`} aria-label="Phone">
                                <i className="bi bi-telephone-fill me-1"></i>
                                <span className="small">{contactInfo.phone}</span>
                            </a>
                </div>
              
              
            </div>
          </div>

          {/* Quick links */}
          <div className="col-6 col-md-2">
            <h6 className="text-uppercase small">Pages</h6>
            <ul className="list-unstyled small mb-0">
              <li><Link to="/" className="footer-link">Home</Link></li>
              <li><Link to="/about" className="footer-link">About</Link></li>
              <li><Link to="/services" className="footer-link">Services</Link></li>
              <li><Link to="/portfolio" className="footer-link">Portfolio</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div className="col-6 col-md-3">
            <h6 className="text-uppercase small">Services</h6>
            <ul className="list-unstyled small mb-0">
              <li><Link to="/services" className="footer-link">Web Development</Link></li>
              <li><Link to="/services" className="footer-link">Testing & QA</Link></li>
              <li><Link to="/services" className="footer-link">Hosting & DevOps</Link></li>
              <li><Link to="/services" className="footer-link">Maintenance</Link></li>
            </ul>
          </div>

          {/* Newsletter & social */}
          <div className="col-12 col-md-3">
            <h6 className="text-uppercase small">Newsletter</h6>
            <p className="small text-white-50">Short tips, occasional updates — no spam.</p>

            <form onSubmit={submitNewsletter} className="d-flex gap-2 mb-2">
              <label htmlFor="footer-news" className="visually-hidden">Email</label>
              <input
                id="footer-news"
                type="email"
                value={newsEmail}
                onChange={(e) => setNewsEmail(e.target.value)}
                className="form-control form-control-sm"
                placeholder="you@example.com"
                aria-label="Email for newsletter"
              />
              <button className="btn btn-primary btn-sm" type="submit" aria-label="Subscribe">Join</button>
            </form>
            {newsMsg && (
              <div className={`small ${newsMsg.type === "error" ? "text-danger" : "text-success"}`}>
                {newsMsg.text}
              </div>
            )}

            <div className="mt-3">
              <a className="me-2 text-white-50" href={`https://wa.me/${contactInfo.whatsapp.replace(/\D/g, "")}`} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                <i className="bi bi-whatsapp fs-5"></i>
              </a>
              <a className="me-2 text-white-50" href="#" aria-label="LinkedIn">
                <i className="bi bi-linkedin fs-5"></i>
              </a>
              <a className="me-2 text-white-50" href="#" aria-label="GitHub">
                <i className="bi bi-github fs-5"></i>
              </a>
              <a className="text-white-50" href="#" aria-label="Twitter">
                <i className="bi bi-twitter fs-5"></i>
              </a>
            </div>
          </div>
        </div>

        {/* bottom row */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center border-top border-secondary mt-4 pt-3">
          <div className="small text-white-50">&copy; {new Date().getFullYear()} SWSAA. All rights reserved.</div>

          <div className="d-flex align-items-center gap-3 mt-2 mt-md-0">
            <a className="small text-white-50" href="/privacy">Privacy</a>
            <a className="small text-white-50" href="/terms">Terms</a>
            <button className="btn btn-sm btn-outline-light" onClick={backToTop} aria-label="Back to top">↑ Top</button>
          </div>
        </div>
      </div>
    </footer>
  );
}
